export const BRAND_NAME = "Sitka Seafood Market";